export default "__VITE_ASSET__7a75fbdc__"